export default {
    'validation.maxlength': 'This field cannot exceed {length} characters',
    'validation.minlength': 'This field must be at least {length} characters',
    'validation.max': 'This field cannot exceed {length}',
    'validation.min': 'This field must be at least {length}',
    'validation.gte': 'This field must be greater than or equal to {value}',
    'validation.lte': 'This field must be less than or equal to {value}',
    'validation.gt': 'This field must be greater than {value}',
    'validation.lt': 'This field must be less than {value}',
    'validation.required': 'This field is required',
    'validation.email': 'Please enter a valid email address',
    "validation.phone.not_valid": "Please enter a valid phone number",
    'validation.numeric': 'Please enter a valid number',
    'validation.date': 'Please enter a valid date',
    'validation.url': 'Please enter a valid URL',
    'validation.mismatch': 'The values do not match',
    'validation.invalid_selection': 'Please select a valid option',
    'validation.serial_number_not_valid': 'This serial number not valid',
    'validation.upload_file_size_lt': '{filename} should is less than {size} {unit}',
    'validation.upload_file_not_allowed_types': '{filename} is not a Allowed File Types',
    'validation.upload_file_success': '{filename} uploaded successfully.',
    'validation.upload_file_fail': '{filename} upload failed.',
    'validation.upload_len': 'Please upload file',
    'validation.records': 'Please select the records',
    "validation.delete.items": "{value} items deleted",
}
